import React, { useState } from 'react';
import { examQuestionBank } from '../../data/index';
import ExamInterface from './ExamInterface';

const ExamCenter = () => {
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedMode, setSelectedMode] = useState(null);
  const [showExamInterface, setShowExamInterface] = useState(false);

  const handleStartExam = (examId, mode) => {
    setSelectedExam(examId);
    setSelectedMode(mode);
    setShowExamInterface(true);
  };

  const handleExamComplete = (examRecord) => {
    console.log('考試完成:', examRecord);
    setShowExamInterface(false);
    setSelectedExam(null);
    setSelectedMode(null);
    // 這裡可以添加成績保存邏輯
  };

  const handleExitExam = () => {
    setShowExamInterface(false);
    setSelectedExam(null);
    setSelectedMode(null);
  };

  if (showExamInterface && selectedExam && selectedMode) {
    return (
      <ExamInterface
        examId={selectedExam}
        mode={selectedMode}
        studentId={1} // 實際應用中從用戶狀態獲取
        onComplete={handleExamComplete}
        onExit={handleExitExam}
      />
    );
  }

  return (
    <div className="exam-center">
      <div className="page-header">
        <h1>考試中心</h1>
        <p>選擇考試和模式開始測驗</p>
      </div>

      <div className="exam-grid">
        {examQuestionBank.map(exam => (
          <div key={exam.id} className="exam-card">
            <div className="exam-card-header">
              <h3>{exam.name}</h3>
              <span className={`difficulty-badge ${exam.difficulty}`}>
                {exam.difficulty}
              </span>
            </div>
            
            <div className="exam-info">
              <p className="exam-description">{exam.description}</p>
              
              <div className="exam-stats">
                <div className="stat">
                  <span className="stat-label">題目數量</span>
                  <span className="stat-value">{exam.totalQuestions}</span>
                </div>
                <div className="stat">
                  <span className="stat-label">及格分數</span>
                  <span className="stat-value">{exam.passingScore}%</span>
                </div>
                <div className="stat">
                  <span className="stat-label">課程</span>
                  <span className="stat-value">{exam.course}</span>
                </div>
              </div>
            </div>

            <div className="exam-modes">
              <h4>選擇模式</h4>
              
              <div className="mode-options">
                {(exam.modes ? Object.entries(exam.modes) : Object.entries({
                  examMode: { name: '考試模式', timeLimit: 90, showAnswers: false, allowReview: false },
                  studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true }
                })).map(([modeKey, modeInfo]) => (
                  <div key={modeKey} className="mode-option">
                    <div className="mode-info">
                      <h5>{modeInfo.name}</h5>
                      <p>{modeInfo.description}</p>
                      
                      <div className="mode-details">
                        {modeInfo.timeLimit && (
                          <span className="mode-detail">
                            ⏱️ {modeInfo.timeLimit} 分鐘
                          </span>
                        )}
                        {!modeInfo.timeLimit && (
                          <span className="mode-detail">
                            ⏱️ 無時間限制
                          </span>
                        )}
                        <span className="mode-detail">
                          {modeInfo.showAnswers ? '✅ 即時答案' : '❌ 完成後顯示'}
                        </span>
                        <span className="mode-detail">
                          {modeInfo.allowReview ? '📖 可複習' : '🚫 不可複習'}
                        </span>
                      </div>
                    </div>
                    
                    <button
                      className={`mode-btn ${modeKey}`}
                      onClick={() => handleStartExam(exam.id, modeKey)}
                    >
                      開始 {modeInfo.name}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExamCenter; 